import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFormStore } from '../../state/FormStore';


export function FixedPanel({ verandaSize, verandaColor, opaalTexture, verandaStartPosition, nodes, materials }) {
    const { formData, getRightFixedPanelColor, getLeftFixedPanelColor } = useFormStore();

    const rightPanelColor = getRightFixedPanelColor();
    const leftPanelColor = getLeftFixedPanelColor();
    return (

        <group scale={[verandaSize[0], verandaSize[1], verandaSize[2]]}>
            {
                (['Glas', 'Helder - Polycarbonnat'].includes(formData.linker.linker_wand_option) && formData.linker.linker_spie_option !== 'Geen') && (
                    <>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_left.geometry}
                            material={materials['Material.004']}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_left_1.geometry}
                            material={materials.silver}>
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_left_2.geometry}
                            material={materials.silver}>
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_left_3.geometry}
                            material={materials.silver}>
                            <meshStandardMaterial attach="material" map={opaalTexture} color={leftPanelColor[0]} transparent opacity={leftPanelColor[1]} />
                        </mesh>
                    </>
                )
            }


            {
                (['Glas', 'Helder - Polycarbonnat'].includes(formData.linker.linker_wand_option) && formData.linker.linker_spie_option === 'Geen') && (
                    <>
                        {/* Replace these with the other meshes you want to show */}
                        <group>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_left.geometry}
                            >
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>

                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_left_1.geometry}
                                material={materials['lambert3.002']}
                            />
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_left_2.geometry}>
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>

                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_left_3.geometry}>
                                <meshStandardMaterial attach="material" map={opaalTexture} color={leftPanelColor[0]} transparent opacity={leftPanelColor[1]} /></mesh>

                        </group>
                    </>
                )}


            {
                (['Glas', 'Helder - Polycarbonnat'].includes(formData.rechter.rechter_wand_option) && formData.rechter.rechter_spie_option !== 'Geen') && (
                    <>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_right.geometry}
                            material={materials['Material.004']}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_right_1.geometry}
                            material={materials.silver}>
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_right_2.geometry}
                            material={materials.silver}>
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.panel_right_3.geometry}
                            material={materials.silver}>
                            <meshStandardMaterial attach="material" map={opaalTexture} color={rightPanelColor[0]} transparent opacity={rightPanelColor[1]} />
                        </mesh>
                    </>
                )}

            {
                (['Glas', 'Helder - Polycarbonnat'].includes(formData.rechter.rechter_wand_option) && formData.rechter.rechter_spie_option === 'Geen') && (
                    <>
                        {/* Replace these with the other meshes you want to show */}
                        <group >
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_right.geometry}
                            >
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>

                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_right_1.geometry}
                                material={materials['lambert3.002']}
                            />
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_right_2.geometry}
                                material={materials['skeleton_mat.004']}>
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>

                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.panel_large_right_3.geometry}
                            >
                                <meshStandardMaterial attach="material" map={opaalTexture} color={rightPanelColor[0]} transparent opacity={rightPanelColor[1]} />
                            </mesh>

                        </group>
                    </>
                )}



        </group>
    );
}

//useGLTF.preload('/veranda3/veranda3.glb');
